import React from "react";
import { FormRuntime } from "../../FormRuntime";
import { ValueSliderFormControl } from "../Web/ValueSliderFormControl";
import { XStackContainer } from "../../Containers";
import { FormConfiguration } from "../../FormConfiguration";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: ValueSliderFormControl } {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    ui.add(container);

    let valueSlider = new ValueSliderFormControl();
    valueSlider.label = " Value Slider With String";
    valueSlider.valueName = "valueSlider";
    valueSlider.sliderValues = ["Pizza", "Beer", "Fruits", "Kale"];
    container.add(valueSlider);

    return { form: ui, control: valueSlider };
}

export const ValueSliderStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values[ui.control.valueName!] = "Fruits";
            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Value Slider",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values[ui.control.valueName!] = "Fruits";
            ui.control.labelSize = 15;

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Value Slider",
        "Label Size",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            data.values[ui.control.valueName!] = "Fruits";
            ui.control.selectValuesToLeft = true;

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Value Slider",
        "Select Values To Left",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            ui.control.isDynamic = true;
            ui.control.stepsValueName = "stepsValues";
            data.values["stepsValues"] = ["Beginner", "Junior", "Senior", "Master"];
            data.values["valueSlider"] = "Senior";

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Value Slider",
        "Steps From Data",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let data = new ExecutionData();
            ui.control.isDynamic = true;
            ui.control.selectValuesToLeft = true;
            ui.control.stepsValueName = "stepsValues";
            data.values["stepsValues"] = ["Beginner", "Junior", "Senior", "Master"];
            data.values["valueSlider"] = "Senior";

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "Value Slider",
        "Steps From Data With Select Left",
    ),
];
